<template>
  <div class="search-conditions">
    <div class="row">
      <div class="col header" style="width:12%">
        <div class="subtitle">거래 날짜 / 시간 (시작)</div>
      </div>
      <div class="col header" style="width:12%">
        <div class="subtitle">거래 날짜 / 시간 (끝)</div>
      </div>
      <div v-if="searchType!=='nonpayment'" class="col header" style="width:10%">
        <div class="subtitle">승인 결과</div>
      </div>
      <div class="col header" style="width:10%">
        <div class="subtitle">결제 수단</div>
      </div>
      <div class="col header" style="width:10%">
        <div class="subtitle">거래 형태</div>
      </div>
      <div class="col header one" :style="searchType!=='nonpayment' ? 'width:46%' : 'width:56%'">
        <div class="subtitle">키워드(주소/장소)</div>
      </div>
    </div>

    <div class="row">
      <div class="col" style="width:12%">
        <date-picker
          type="datetime"
          v-model="startDateTime"
          input-class="datetime"
          style="width: 100%;"
          :show-second="false"
          format="YYYY.MM.DD HH:mm"
          :confirm="true"
          value-type="YYYY.MM.DD HH:mm"
        ></date-picker>
      </div>
      <div class="col" style="width:12%">
        <date-picker
          type="datetime"
          v-model="endDateTime"
          input-class="datetime"
          style="width: 100%;"
          :show-second="false"
          format="YYYY.MM.DD HH:mm"
          :confirm="true"
          value-type="YYYY.MM.DD HH:mm"
        ></date-picker>
      </div>

      <div v-if="searchType!=='nonpayment'" class="col" style="width:10%">
        <div class="select">
          <select v-model="approveResult">
            <option v-for="item in approveResults" :key="item">
              {{ item }}
            </option>
          </select>

          <img
            v-if="approveResult"
            src="/static/img/ico-close.png"
            @click="approveResult = null"
          />
        </div>
      </div>
      <div class="col" style="width:10%">
        <div class="select">
          <select v-model="paymentMode">
            <option v-for="item in paymentModes" :key="item">
              {{ item }}
            </option>
          </select>

          <img
            v-if="paymentMode"
            src="/static/img/ico-close.png"
            @click="paymentMode = null"
          />
        </div>
      </div>
      <div class="col" style="width:10%">
        <div class="select">
          <select v-model="approveType">
            <option v-for="item in approveTypes" :key="item">
              {{ item }}
            </option>
          </select>

          <img
            v-if="approveType"
            src="/static/img/ico-close.png"
            @click="approveType = null"
          />
        </div>
      </div>
      <div class="col desc" :style="searchType!=='nonpayment' ? 'width:26%' : 'width:36%'">
        <input
          class="span"
          v-model="keyword"
          type="text"
          placeholder="결제 주소 및 장소에 포함된 키워드를 입력해주세요."
        />
      </div>
      <div class="col btn" style="width:10%">
        <button class="btn blue" @click="search">
          <img src="/static/img/ico-magnify.png" alt />
          결제기록 검색
        </button>
      </div>
      <div class="col btn" style="width:10%">
        <button class="btn orange" @click="downloadResult">
          <span v-if="!downloading">
            <img src="/static/img/ico-microsoft-excel.png" alt />
            excel
          </span>
          <ButtonLoading v-else></ButtonLoading>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-useless-escape */
/* eslint-disable no-console */
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  props: [
    'searchType',
    'tab',
    'downloading',
  ],
  components: {
    DatePicker,
    ButtonLoading,
  },
  data: () => ({
    startDateTime: null,
    endDateTime: null,
    approveResults: [],
    approveResult: null,
    paymentModes: [],
    paymentMode: null,
    approveTypes: [],
    approveType: null,
    keyword: '',
    searchCondition: '',
    limitApproveCancelDay: 7,
  }),
  created() {
    for (let i = 0; i < this.$approveResult.length; i++) {
      this.approveResults.push(this.$approveResult[i].name);
    }

    for (let i = 0; i < this.$paymentMode.length; i++) {
      this.paymentModes.push(this.$paymentMode[i].name);
    }

    for (let i = 0; i < this.$approveType.length; i++) {
      this.approveTypes.push(this.$approveType[i].name);
    }

    this.initDate();
  },
  mounted() {
    this.search();
  },
  watch: {
    tab: {
      handler() {
        if (this.tab === 0) {
          this.initDate();
        } else if (this.tab === 1) {
          this.endDateTime = this.$moment().format('YYYY.MM.DD HH:mm:ss');
        }
        this.search();
      },
    },
  },
  methods: {
    getLimitDateTime() {
      let start = null;
      let end = null;
      if (this.searchType === 'claim') {
        start = this.$moment().add(-this.limitApproveCancelDay, 'day').format('YYYY.MM.DD HH:mm:ss');
        end = this.$moment().format('YYYY.MM.DD HH:mm:ss');
      } else if (this.searchType === 'refund') {
        start = null;
        end = this.$moment().add(-this.limitApproveCancelDay, 'day').format('YYYY.MM.DD HH:mm:ss');
      } else if (this.searchType === 'nonpayment') {
        start = null;
        end = this.$moment().format('YYYY.MM.DD HH:mm:ss');
      }
      return [start, end];
    },
    initDate() {
      [this.startDateTime, this.endDateTime] = this.getLimitDateTime();
    },
    getSearchCondition() {
      this.searchCondition = '';
      let approveResult = '';
      let paymentMode = '';
      let approveType = '';
      let keyword = '';

      const [limitStart, limitEnd] = this.getLimitDateTime();

      if (this.tab === 0) { // "사용 내역 조회"인 경우에만 적용
        if (this.searchType === 'claim') {
          if (this.startDateTime === null) {
            alert('시작 날짜를 입력해 주세요.');
            return [false, '', '', ''];
          } else if (this.startDateTime < limitStart || this.endDateTime > limitEnd) {
            alert(`최근 ${this.limitApproveCancelDay}일간의 결제건만 검색하실 수 있습니다.`);
            return [false, '', '', ''];
          }
        } else if (this.searchType === 'refund') {
          if (this.endDateTime === null) {
            alert('끝 날짜를 입력해 주세요.');
            return [false, '', '', ''];
          } else if (this.endDateTime > limitEnd) {
            alert(`${this.limitApproveCancelDay}일 이전의 결제건만 검색하실 수 있습니다.`);
            return [false, '', '', ''];
          }
        } else if (this.searchType === 'nonpayment') {
          // do nothing
        }
      }

      if (this.approveResult) {
        approveResult = this.$getConstCode('approveResult', this.approveResult);
      }
      if (this.paymentMode) {
        paymentMode = this.$getConstCode('paymentMode', this.paymentMode);
      }
      if (this.approveType) {
        approveType = this.$getConstCode('approveType', this.approveType);
      }

      if (this.keyword) {
        keyword = this.keyword;
      }

      let searchCondition = '';
      if (this.startDateTime) {
        // searchCondition += `&from=${encodeURIComponent(this.startDateTime)}`;
        searchCondition += `&from=${encodeURIComponent(new Date(this.startDateTime).toISOString())}`;
      }
      if (this.endDateTime) {
        // searchCondition += `&to=${encodeURIComponent(this.endDateTime)}`;
        searchCondition += `&to=${encodeURIComponent(new Date(this.endDateTime).toISOString())}`;
      }
      if (approveResult) {
        searchCondition += `&approveResult=${encodeURIComponent(
          approveResult,
        )}`;
      }
      if (paymentMode) {
        searchCondition += `&paymentMode=${encodeURIComponent(paymentMode)}`;
      }
      if (approveType) {
        searchCondition += `&approveType=${encodeURIComponent(approveType)}`;
      }

      if (keyword) {
        searchCondition += `&keyword=${encodeURIComponent(keyword)}`;
      }
      searchCondition = searchCondition.replace('&', '');
      return [true, searchCondition, this.startDateTime, this.endDateTime];
    },
    search() {
      const [result, searchCondition, startDateTime, endDateTime] = this.getSearchCondition();
      if (result) {
        this.searchCondition = searchCondition;
        this.$emit('search', this.searchCondition, startDateTime, endDateTime);
      }
    },
    downloadResult() { // TODO
      this.tab = 1; // TODO
      const [result, searchCondition, startDateTime, endDateTime] = this.getSearchCondition();
      this.tab = 0; // TODO
      if (result) {
        this.searchCondition = searchCondition;
        this.$emit('downloadResult', this.searchCondition, startDateTime, endDateTime);
      }
    },
  },
};
</script>

<style scoped>
.search-conditions .row {
  display: flex;
  height: 40px;
}
.search-conditions .row.space {
  margin-top: 48px;
}
.search-conditions .row .col {
  width: 100%;
  text-align: center;
}

.search-conditions .row .col:not(:last-child) {
  margin-right: 12px;
}

.search-conditions .row .col.header {
  text-align: left;
  margin-left: 10px;
  padding-top: 10px;
}
.search-conditions .row .col.btn {
  max-width: 130px;
}
.search-conditions .title {
  margin-bottom: 26px;
}
.search-conditions .subtitle {
  margin-bottom: 5px;
  font-size: 14.8px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: 0.19px;
  color: #212121;
}
.search-conditions input {
  padding: 16px 8px 16px 16px;
  width: 100%;
  height: 100%;
  border: solid 0.5px #686868;
}
.search-conditions input::placeholder {
  font-size: 14.8px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: 0.19px;
  color: rgba(72, 72, 72, 0.64);
}
.search-conditions .select {
  position: relative;
}
.search-conditions .select select {
  padding-left: 10px;
  width: 100%;
  height: 40px;
  border: solid 0.5px #686868;
  font-size: 14.8px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: 0.19px;
}
.search-conditions .select img {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 50%;
  right: 36px;
  transform: translate(0, -50%);
  cursor: pointer;
}
.search-conditions .btn {
  width: 100%;
  height: 40px;
  text-align: center;
  font-size: 12.8px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  color: #ffffff;
  border-radius: 2px;
  transition: 0.2s;
  cursor: pointer;
}
.search-conditions .btn img {
  width: 24px;
  height: 24px;
  vertical-align: middle;
}
.btn.blue {
  background-color: #0058EE;
}
.btn.blue .btn:hover {
  background-color: #0068fe;
}
.btn.orange {
  background-color: #FC8145;
}
.btn.orange .btn:hover {
  background-color: #FC8100;
}
.btn.redpink {
  background-color: #D01156;
}
.btn.redpink .btn:hover {
  background-color: #D01100;
}
</style>



// WEBPACK FOOTER //
// src/components/claim/SearchConditions.vue